import { createSlice } from '@reduxjs/toolkit';
import AxiosAdapter from './AxiosAdapter';

import { MESSAGE } from 'src/app/constant/message';
import { HTTP_GETTYPE, STATUS_API } from '../app/constant/config';

export const getListCustomer = AxiosAdapter.GetHttp(
  'customerSlice/getlistCustomer',
  '/agencies/statistic/devices/user',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const createCustomer = AxiosAdapter.HttpPost(
  'customerSlice/createCustomer',
  '/agencies/create/enduser',
  MESSAGE.CREATE_AGENCY_SUCCESS,
  'Tạo mới khách hàng thất bại'
);

export const getListFeedbacks = AxiosAdapter.GetHttp(
  'customerSlice/getListFeedbacks',
  '/users/get/all/comments',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const getListActionLogs = AxiosAdapter.GetHttp(
  'customerSlice/getListActionLogs',
  '/action-logs',
  HTTP_GETTYPE.ALL_PAGINATION
);

export const customerSlice = createSlice({
  name: 'customerSlice',
  initialState: {
    listCustomer: [],
    listFeedbacks: [],
    listActionLogs: [],

    totalCustomer: 0,
    totalFeedback: 0,
    totalActionLogs: 0,

    error: null,
    statusGet: null,
    statusCreate: null,
    isLoading: false
  },

  reducers: {
    resetChange: state => {
      state.statusGet = null;
      state.statusCreate = null;
      state.isLoading = false;
      state.error = null;
    }
  },

  extraReducers: {
    [getListCustomer.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListCustomer.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listCustomer = action.payload.payload.data;
      state.totalCustomer = action.payload.payload.numberOfItems;
      state.isLoading = false;
    },
    [getListCustomer.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    [createCustomer.pending]: state => {
      state.statusCreate = STATUS_API.PENDING;
    },
    [createCustomer.fulfilled]: (state, action) => {
      state.statusCreate = STATUS_API.SUCCESS;
    },
    [createCustomer.rejected]: (state, action) => {
      state.statusCreate = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
    },
    [getListFeedbacks.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListFeedbacks.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listFeedbacks = action.payload.payload.result;
      state.totalFeedback = action.payload.payload.total;
      state.isLoading = false;
    },
    [getListFeedbacks.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    },
    // Get Action Logs
    [getListActionLogs.pending]: state => {
      state.statusGet = STATUS_API.PENDING;
      state.isLoading = true;
    },
    [getListActionLogs.fulfilled]: (state, action) => {
      state.statusGet = STATUS_API.SUCCESS;
      state.listActionLogs = action.payload.payload.result;
      state.totalActionLogs = action.payload.payload.number_of_item;
      state.isLoading = false;
    },
    [getListActionLogs.rejected]: (state, action) => {
      state.statusGet = STATUS_API.ERROR;
      state.error = action.payload?.message || action.error;
      state.isLoading = false;
    }
  }
});

export const { resetChange } = customerSlice.actions;

export default customerSlice.reducer;
